/**
 * D13 — lost-customer threshold (`custLife.*`): the "Klienci" section of Administration → Settings. Merged into the dictionary
 * through `extra.ts`; `custLifeEn` is typed against `custLifePl`, so a missing key is a compile error.
 */
type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

export const custLifePl = {
  section: 'Klienci',
  sectionHint: 'Kiedy klient przestaje być aktywny i liczy się jako utracony.',
  lostAfterDays: 'Klient utracony po',
  days: 'dniach bez zakupu',
  hint:
    'Zakup = dostawa (WZ), paragon albo faktura bez WZ. Próg działa wszędzie: status klienta, zdarzenia „utracony” i „odzyskany” na pulpitach, analiza utraconych, RFM i ryzyko odejścia. Klient aktywny — zakup w ciągu {active} dni.',
  history:
    'Zdarzenia są liczone wstecz dla całej historii — po zmianie progu zmienią się też liczby utraconych i odzyskanych w poprzednich miesiącach. Przeliczenie trwa do kilku minut.',
  range: 'Dozwolone {min}–{max} dni.',
  save: 'Zapisz',
  saved: 'Zapisano. Statusy i zdarzenia klientów przeliczają się w tle.',
  saveFailed: 'Nie udało się zapisać progu.',
  loadError: 'Nie udało się wczytać ustawień klientów.',
  readOnly: 'Zmienić może administrator.',
};

export const custLifeEn: Shape<typeof custLifePl> = {
  section: 'Customers',
  sectionHint: 'When a customer stops being active and counts as lost.',
  lostAfterDays: 'Customer lost after',
  days: 'days without a purchase',
  hint:
    'Purchase = delivery (WZ), receipt or an invoice without WZ. The threshold applies everywhere: customer status, "lost" and "recovered" events on dashboards, lost-customer analysis, RFM and churn risk. Active customer — a purchase within {active} days.',
  history:
    'Events are computed back over the whole history — after a change the lost and recovered counts of past months change too. Recalculation takes up to a few minutes.',
  range: 'Allowed {min}–{max} days.',
  save: 'Save',
  saved: 'Saved. Customer statuses and events are being recalculated in the background.',
  saveFailed: 'Could not save the threshold.',
  loadError: 'Could not load the customer settings.',
  readOnly: 'Only an administrator can change it.',
};
